/**
 * 用户访问路径上报
 */

import qs from 'qs';
import Axios from 'axios';

class VisitReport {
  constructor(options) {
    this.fromName = options?.fromName || ''; // 来源页面名称
    this.name = options?.name || ''; // 页面名称
    this.extraInfo = options?.extraInfo || {};
  }

  report() {
    const data = {
      from_name: this.fromName,
      name: this.name,
      ts: new Date().getTime(),
      extra_info: JSON.stringify(this.extraInfo),
    };

    return Axios({
      url: '/user_operation/page_visit_record/',
      method: 'post',
      data: qs.stringify(data),
    });
  }
}

const visitRecordReport = options => {
  return new Promise(resolve => {
    const visitRecord = new VisitReport(options);
    visitRecord
      .report()
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        resolve(err);
      });
  });
};

export { VisitReport, visitRecordReport };
